// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__DkBja","footer":"ChangeClinic_footer__3BaZo"};